export const currentUser = (state) => {
    return state.auth.auth
};